<template>
  <div class="divider-section" :class="{'isBold':isBold}">

    <div class="main-container">
      <div class="plus-icon-container-mobile">
        <div class="line"></div>
        <svg width="21" height="20" viewBox="0 0 21 20" fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5 1C11.5 0.447715 11.0523 0 10.5 0C9.94772 0 9.5 0.447715 9.5 1V9H1.5C0.947715 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11H9.5V19C9.5 19.5523 9.94772 20 10.5 20C11.0523 20 11.5 19.5523 11.5 19V11H19.5C20.0523 11 20.5 10.5523 20.5 10C20.5 9.44772 20.0523 9 19.5 9H11.5V1Z"
            fill="currentColor"/>
        </svg>
      </div>
      <div class="divider-label caps-medium">{{ label }}</div>
      <div class="line-container">
        <div class="arrow-container">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="0.087126in" height="0.153417in"
               version="1.1"
               style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
               viewBox="0 0 0.63 1.12">
            <path fill="currentColor" id="Line_x0020_0.svg" class="fil0"
                  d="M0.02 0.5c-0.03,0.03 -0.03,0.08 0,0.11l0.48 0.48c0.03,0.03 0.08,0.03 0.11,0 0.03,-0.03 0.03,-0.08 0,-0.11l-0.43 -0.43 0.43 -0.43c0.03,-0.03 0.03,-0.08 0,-0.11 -0.03,-0.03 -0.08,-0.03 -0.11,0l-0.48 0.48z"/>
</svg>
        </div>
        <div class="line"></div>
      </div>
      <div class="plus-icon-container">
        <div class="line line-mobile"></div>
        <svg width="21" height="20" viewBox="0 0 21 20" fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5 1C11.5 0.447715 11.0523 0 10.5 0C9.94772 0 9.5 0.447715 9.5 1V9H1.5C0.947715 9 0.5 9.44771 0.5 10C0.5 10.5523 0.947715 11 1.5 11H9.5V19C9.5 19.5523 9.94772 20 10.5 20C11.0523 20 11.5 19.5523 11.5 19V11H19.5C20.0523 11 20.5 10.5523 20.5 10C20.5 9.44772 20.0523 9 19.5 9H11.5V1Z"
            fill="currentColor"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DividerSection',
  props: {
    label: {
      type: String,
      default: true,
    },
    isBold: {
      type: Boolean,
      default: false,
    },
  }

}
</script>

<style lang="scss">
@import "DividerSection.scss";
</style>
